

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_spacing";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_spacing__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"spacing01":"1px","spacing02":"2px","spacing03":"3px","spacing06":"6px","spacing12":"12px","spacing18":"18px","spacing24":"24px","spacing30":"30px","spacing36":"36px","spacing42":"42px","spacing48":"48px","spacing78":"78px","spacing90":"90px","DefaultSpacing":"6px","Spacing":"var(--wds-space-100, 6px)","SP1":"calc(var(--wds-space-100, 6px) * 1)","SP2":"calc(var(--wds-space-100, 6px) * 2)","SP3":"calc(var(--wds-space-100, 6px) * 3)","SP4":"calc(var(--wds-space-100, 6px) * 4)","SP5":"calc(var(--wds-space-100, 6px) * 5)","SP6":"calc(var(--wds-space-100, 6px) * 6)","SP7":"calc(var(--wds-space-100, 6px) * 7)","SP8":"calc(var(--wds-space-100, 6px) * 8)","SP9":"calc(var(--wds-space-100, 6px) * 9)","SP10":"calc(var(--wds-space-100, 6px) * 10)"}; 
export var vars = {"wds-space-100":"--wds-space-100"}; 




